import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LanguageService } from '../../../../../../../shared/services/language.service';

@Component({
  selector: 'app-edit-transport-weekoverview',
  templateUrl: './edit-transport-weekoverview.component.html',
  styleUrls: ['./edit-transport-weekoverview.component.css']
})
export class EditTransportWeekoverviewComponent implements OnInit, OnChanges {

  @Input() gridDataSource: any;
  @Input() height = 230;
  @Input() widthTimeTypeCategory = 60;
  @Input() showTitle = false;
  @Input() overTimeCheckActive: boolean; 
  @Input() customTitle: string = ""; 

  weekDayColumnWidth = 120;
  gridWithSummaryDataSource = [];
  gridWithoutSummaryDataSource = [];

  @Input()
  set setWeekNo(no: number) {
    this.weekNo = no;
    this.setHeaderTitle();
  }

  weekNo: number;
  headerTitle = "";

  constructor(public languageService: LanguageService) { }

  ngOnInit() {
    this.setHeaderTitle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.gridDataSource || changes.gridDataSource.previousValue === changes.gridDataSource.currentValue) { return; }

    if (this.hasOnlyAmlTimes()) {
      this.gridDataSource = [];
    }

    this.gridWithSummaryDataSource = this.gridDataSource.filter((e: any) => e.UseInSummary);
    this.gridWithoutSummaryDataSource = this.gridDataSource.filter((e: any) => !e.UseInSummary);
  }

  private hasOnlyAmlTimes(): boolean {
    return this.gridDataSource.every((e: any) => e.IsAmlTime);
  }

  setHeaderTitle() {
    if (this.weekNo > 0) {
      this.headerTitle = this.languageService.LNG("Label.Overview") + " " + this.languageService.LNG("Label.Week") + " " + this.weekNo;
    }
    else {
      this.headerTitle = this.languageService.LNG("Label.Overview") + " " + this.languageService.LNG("Label.Week");
    }
  }

  onToolbarPreparing(e: any) {
    if (this.showTitle) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'headerTitle'
      });
    }
  }

  onCellPrepared(e: any) {
    if (e.rowType === "totalFooter") {
      e.cellElement.style.padding = "0 5px 0 5px"; 
    }

    if (e.rowType !== "data") { return; }
    this.paintOvertimeRowRedIfOvertimeAndNotEnoughNormalTime(e);
  }

  private paintOvertimeRowRedIfOvertimeAndNotEnoughNormalTime(e: any) {    
    if (e.data && e.data.HasOvertimeButNotEnoughNormalTime === false) { return; }
    if (this.overTimeCheckActive) {
      e.cellElement.style.background = "var(--red)";
      e.cellElement.style.color = "#fff";
    }
  }

  calculateSummary(options: any) {
    switch(options.summaryProcess) {
      case "start":
          // Initializing "totalValue" here
          options.totalValue = 0;
          break;
      case "calculate":
        switch (options.name) {
          case "SumMonday":
            if (options.value.UseInSummary && options.value.SecondsMonday > 0)
            {
              options.totalValue += options.value.SecondsMonday;
            }
            break;
          case "SumTuesday":
            if (options.value.UseInSummary && options.value.SecondsTuesday > 0)
            {
              options.totalValue += options.value.SecondsTuesday;
            }
            break;
          case "SumWednesday":
            if (options.value.UseInSummary && options.value.SecondsWednesday > 0)
            {
              options.totalValue += options.value.SecondsWednesday;
            }
            break;
          case "SumThursday":
            if (options.value.UseInSummary && options.value.SecondsThursday > 0)
            {
              options.totalValue += options.value.SecondsThursday;
            }
            break;
          case "SumFriday":
            if (options.value.UseInSummary && options.value.SecondsFriday > 0)
            {
              options.totalValue += options.value.SecondsFriday;
            }
            break;
          case "SumSaturday":
            if (options.value.UseInSummary && options.value.SecondsSaturday > 0)
            {
              options.totalValue += options.value.SecondsSaturday;
            }
            break;
          case "SumSunday":
            if (options.value.UseInSummary && options.value.SecondsSunday > 0)
            {
              options.totalValue += options.value.SecondsSunday;
            }
            break;
          case "SumTotal":
            if (options.value.UseInSummary && options.value.SecondsMonday > 0)
            {
              options.totalValue += options.value.SecondsMonday;
            }
            if (options.value.UseInSummary && options.value.SecondsTuesday > 0)
            {
              options.totalValue += options.value.SecondsTuesday;
            }
            if (options.value.UseInSummary && options.value.SecondsWednesday > 0)
            {
              options.totalValue += options.value.SecondsWednesday;
            }
            if (options.value.UseInSummary && options.value.SecondsThursday > 0)
            {
              options.totalValue += options.value.SecondsThursday;
            }
            if (options.value.UseInSummary && options.value.SecondsFriday > 0)
            {
              options.totalValue += options.value.SecondsFriday;
            }
            if (options.value.UseInSummary && options.value.SecondsSaturday > 0)
            {
              options.totalValue += options.value.SecondsSaturday;
            }
            if (options.value.UseInSummary && options.value.SecondsSunday > 0)
            {
              options.totalValue += options.value.SecondsSunday;
            }
            break;
        }
          // Modifying "totalValue" here
          break;
      case "finalize":
          const totalSeconds = options.totalValue;
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);

          options.totalValue = `${hours.toString().padStart(2, '0')} ${minutes.toString().padStart(2, '0')}`;
          break;
    }
  }
}
